import React from 'react';
import { Box } from '@mui/material';
import { FormContainer } from '../molecules/FormContainer';

interface AuthFormSideProps {
  /**
   * Form content to render
   */
  children: React.ReactNode;
  /**
   * Maximum width of the form container
   * @default 500
   */
  maxWidth?: number;
}

/**
 * Organism: Right side form area
 * White background with centered form container
 */
export const AuthFormSide: React.FC<AuthFormSideProps> = ({
  children,
  maxWidth = 500,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <FormContainer maxWidth={maxWidth}>{children}</FormContainer>
    </Box>
  );
};
